<a
  (click)="navigate.emit()"
  [attr.aria-label]="text()"
  [class]="hideTextClass()"
  [href]="href()"
  [trackLinkInfo]="{ type: 'navigation', field: text() }"
  class="button"
  wlTrackLink
>
  <fa-icon
    [fixedWidth]="true"
    [icon]="iconName()"
    class="button__icon align-self-center"
  />
  <span class="button__text">{{ text() }}</span>
</a>
